module.exports = __webpack_public_path__ + "media/images/icons/list_benefit-b49aac8f379eb1628d78055508451bfb.svg";